import {CartSummaryModel} from '../models/checkout/CartSummary/CartSummary.model';
import {ILocaleKeys} from '../../locale-keys/LocaleKeys';
import {TaxModel} from '../models/checkout/CartSummary/Tax.model';
import {DiscountScope} from '../models/checkout/CartSummary/Discount.model';

export const isPartiallyPaid = (cartSummary: CartSummaryModel) => Boolean(cartSummary.paymentSummary.payLater?.amount);
export const hasFreeTrial = (cartSummary: CartSummaryModel) =>
  Boolean(cartSummary.paymentSummary.payAfterFreeTrial?.amount);

export const getTotal = (cartSummary: CartSummaryModel) =>
  !isPartiallyPaid(cartSummary) && !hasFreeTrial(cartSummary)
    ? cartSummary.paymentSummary.payNow.formattedAmount
    : cartSummary.paymentSummary.totalAfterGiftCards.formattedAmount;

export const getTaxName = ({taxName, localeKeys}: {taxName?: string; localeKeys: ILocaleKeys}): string => {
  return taxName || localeKeys.checkout.order_summary.totals.tax();
};

export const formatSignedAmount = ({amount, isRTL}: {amount: string; isRTL: boolean}): string => {
  return isRTL ? /* istanbul ignore next */ `${amount}-` : `-${amount}`;
};

export const isFreeShippingDiscount = (
  cartSummary: CartSummaryModel,
  couponAlignmentInCartAndCheckout: boolean
): boolean => {
  return couponAlignmentInCartAndCheckout
    ? cartSummary?.globalDiscounts.some((discount) => discount.scope === DiscountScope.DELIVERY)
    : Boolean(cartSummary?.couponDiscount?.isFreeShippingCoupon);
};

export const isFullTaxExempt = (tax: TaxModel): boolean => tax.exemptAmount.amount > 0 && tax.amount.amount === 0;

export const isPartialTaxExempt = (tax: TaxModel): boolean => tax.exemptAmount.amount > 0 && tax.amount.amount > 0;

export const getTaxesWithSomeTaxExemption = (taxes: TaxModel[]) =>
  taxes.filter((tax) => isFullTaxExempt(tax) || isPartialTaxExempt(tax));
